import React, { Component } from 'react';
import RelatedProducts from './relatedProducts';
import { getProduct, getProducts } from '../services/productService';
import { getCartItems } from '../services/cartService';
import auth from '../services/authService';
import { Link } from 'react-router-dom';
import Loader from './loader';

class ProductPage extends Component {
  state = {
    user: [],
    products: [],
    product: {},
    quantity: 1,
    loading: true,
  };

  populateProducts = async () => {
    try {
      const productId = this.props.match.params.id;
      const { data: product } = await getProduct(productId);
      const { data: products } = await getProducts();
      this.setState({
        product: this.mapToViewModel(product),
        products,
        loading: false,
        quantity: 1,
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace('/not-found');
    }
  };

  async componentDidMount() {
    // setTimeout(() => this.setState({ loading: false }), 0.002);
    window.scrollTo(0, 0);
    await this.populateProducts();
    const user = auth.getCurrentUser();
    this.setState({ user });
  }

  async componentDidUpdate(prevProps) {
    const productId = this.props.match.params.id;

    if (productId !== prevProps.match.params.id) {
      window.scrollTo(0, 0);
      this.setState({ loading: true });
      // setTimeout(() => this.setState({ loading: false }), 0.002);

      await this.populateProducts();
    }
  }

  mapToViewModel(product) {
    return {
      _id: product._id,
      label: product.label,
      category: product.category,
      price: product.price,
      imageUrl: product.imageUrl,
      size: product.size,
      inStock: product.inStock,
    };
  }

  handleQuantityValue = ({ currentTarget: input }) => {
    let { quantity } = this.state;
    quantity = parseInt(input.value);
    this.setState({ quantity });
  };

  handleIncrement = () => {
    const { quantity } = this.state;
    const incrementedQuantity = quantity + 1;
    this.setState({ quantity: incrementedQuantity });
  };

  handleDecrement = () => {
    const { quantity } = this.state;
    const incrementedQuantity = quantity - 1;
    this.setState({ quantity: incrementedQuantity });
  };

  handleLoading = () => {
    this.setState({ loading: true });
  };

  addToCart = (product, quantity) => {
    this.props.handleCart(product, quantity);
  };

  disbaleAddToCart = () => {
    const cartItems = getCartItems();
    const productId = this.props.match.params.id;
    let buttonOption = false;

    for (const c of cartItems) {
      if (c.product._id === productId) {
        if (c.quantity === c.product.inStock) buttonOption = true;
      }
    }

    return buttonOption;
  };

  // remainingStock = (item) => {
  //   const cartItems = getCartItems();
  //   const productId = this.props.match.params.id;
  //   let remainingQunatity = item.inStock;

  //   for (const c of cartItems) {
  //     if (c.product._id === productId) {
  //       remainingQunatity = item.inStock - c.quantity;
  //     }
  //   }

  //   return remainingQunatity;
  // };

  render() {
    const { product, quantity, products, loading, user } = this.state;
    let delay = 0;

    if (loading) return <Loader />;

    // product.inStock = this.remainingStock(product);

    return (
      <React.Fragment>
        <div className='row p-4 container product-page'>
          <div className='col-md-7 product-image'>
            <img src={product.imageUrl} alt={product.label} />
          </div>

          <div className='col-md-5 product-detail'>
            <h6>{product.category}</h6>
            <h1>{product.label}</h1>
            <h4>{product.size}</h4>
            <p>
              Shipping is included on standard 2-day shipments until September
              30, 2020. Additional charges for overnight shipping.
            </p>
            <h2>PKR {product.price}</h2>
            {user && user.isAdmin && (
              <h4>Available in stock: {product.inStock}</h4>
            )}
            {!this.disbaleAddToCart() && product.inStock > 0 && (
              <div className='quantity'>
                <button
                  className='decrement'
                  disabled={quantity <= 1}
                  onClick={this.handleDecrement}
                >
                  -
                </button>
                <div className='counter-value'>
                  <input
                    type='number'
                    value={quantity}
                    onChange={this.handleQuantityValue}
                  />
                </div>
                <button
                  disabled={quantity >= product.inStock}
                  className='increment'
                  onClick={this.handleIncrement}
                >
                  +
                </button>
              </div>
            )}
            {!this.disbaleAddToCart() &&
              product.inStock >= 1 &&
              product.inStock <= 3 && (
                <p className='product-left'>
                  Only {product.inStock} items left, hurry up!
                </p>
              )}
            {!this.disbaleAddToCart() &&
              quantity > product.inStock &&
              product.inStock !== 0 && (
                <div className='alert alert-danger'>
                  Only {product.inStock} items available!
                </div>
              )}
            {!this.disbaleAddToCart() && product.inStock < 1 && (
              <p className='product-left'>Out of stock!</p>
            )}
            {this.disbaleAddToCart() && (
              <p className='product-left'>
                Only {product.inStock} items were available, you've already
                added all the available items in cart!
              </p>
            )}{' '}
            {user && user.isAdmin && (
              <Link to={`/add-new-product/${product._id}`}>
                <button
                  style={{ width: '100%', fontSize: '20px' }}
                  className='update-pro'
                >
                  Update
                </button>
              </Link>
            )}
            {((user && !user.isAdmin) || !user) && (
              <button
                disabled={
                  this.disbaleAddToCart() ||
                  product.inStock < 1 ||
                  quantity > product.inStock
                }
                className='add-to-cart'
                onClick={() => this.addToCart(product, quantity)}
              >
                Add to cart{' '}
                {quantity > 1
                  ? '- (PKR ' + quantity * product.price + ')'
                  : null}
              </button>
            )}
          </div>
        </div>

        <RelatedProducts
          products={products}
          product={product}
          delay={delay}
          handleLoading={this.handleLoading}
        />
      </React.Fragment>
    );
  }
}

export default ProductPage;
